export default "__VITE_ASSET__BRHup8yq__"